<template>
  <div>
    <div>
      <p v-show="showLabelFrom" class="px-2">出発地</p>
      <p v-show="showLabelTo" class="px-2">目的地</p>
      <div :class="showLabel()">
        <div class="flex">
          <div class="w-full relative">
            <input @focus="$emit('search')" @input="$emit('incrementSearch', $event.target.value)" debounce="500" class="w-full px-8 py-2 border input_border rounded truncate placeholder-gray-600" type="text" :placeholder="showLabelFrom ?'出発地を入力' : showLabelTo? '目的地を入力':$t('tour_map_search_placeholder')" :value="value" />
            <div v-if="value.length > 0" class="absolute right-2 top-0 h-full flex items-center ml-2 focus:outline-none" @click="clearForm">
              <svg v-if="onSearch" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" class="text-body-lighter"><path fill-rule="evenodd" d="m17.9230769 5 1.0769231 1.07692308-5.9240428 5.92278132 5.9240428 5.9233725-1.0769231 1.0769231-5.9233725-5.9240428-5.92278132 5.9240428-1.07692308-1.0769231 5.9224363-5.9233725-5.9224363-5.92278132 1.07692308-1.07692308 5.92278132 5.9224363z"/></svg>
            </div>
            <button @click="$emit('closeSearchPanel')" class="absolute left-0 top-0 h-full flex items-center ml-2 focus:outline-none">
              <svg v-if="onSearch" height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg" class="text-link"><path d="m10 3.20710678v6.29289322c0 .27614237-.22385763.5-.5.5h-6.29289322c-.27614237 0-.5-.22385763-.5-.5 0-.13260824.05267842-.2597852.14644661-.35355339l6.29289322-6.29289322c.19526215-.19526215.51184463-.19526215.70710678 0 .09376819.09376819.14644661.22094515.14644661.35355339z" fill-rule="evenodd" transform="matrix(-.70710678 -.70710678 -.70710678 .70710678 16.485281 10)"/></svg>
              <svg
                v-else
                class="h-4 w-4 text-supplement"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 56.966 56.966"
                width="512"
                height="512">
                <path d="M55.146 51.887L41.588 37.786A22.926 22.926 0 0046.984 23c0-12.682-10.318-23-23-23s-23 10.318-23 23 10.318 23 23 23c4.761 0 9.298-1.436 13.177-4.162l13.661 14.208c.571.593 1.339.92 2.162.92.779 0 1.518-.297 2.079-.837a3.004 3.004 0 00.083-4.242zM23.984 6c9.374 0 17 7.626 17 17s-7.626 17-17 17-17-7.626-17-17 7.626-17 17-17z"/>
              </svg>
            </button>
          </div>
        </div>
        <div v-if="onSearch">
          <div class="text-right pt-2 pb-1">
            <a @click="$emit('openGenreList')" class="flex items-center justify-end text-link text-sm">
              {{ $t('tour_genre_list_link') }}
              <svg enable-background="new 0 0 20 20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" class="pl-1 h-5"><path clip-rule="evenodd" d="m8.9 5.2 4.4 4.4c.2.2.2.5 0 .7l-4.4 4.4c-.2.2-.5.2-.7 0-.1 0-.2-.1-.2-.3v-8.9c0-.3.2-.5.5-.5.1.1.3.1.4.2z" fill-rule="evenodd" /></svg>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    onSearch: {
      type: Boolean,
      required: true
    },
    value: {
      type: String,
      required: true
    },
    showLabelFrom: {
      type: Boolean,
      required: false,
      default:false
    },
    showLabelTo: {
      type: Boolean,
      required: false,
      default:false
    }
  },
  methods: {
    clearForm: function () {
      this.$emit('clearForm')
    },
    showLabel: function () {
      if (this.showLabelFrom || this.showLabelTo) {
        return 'py-2 px-2'
      } else {
        return 'py-4 px-2'
      }
    }
  },
  watch: {
    value: function () {
      this.$emit('incrementSearch', this.value)
    }
  }
}
</script>